<template>
  <footer
    class="footer"
    :class="is_white ? 'white' : ''"
  >
    <div class="base-container-first footer__container typography__body1">
      <ul class="footer__content">
        <li>
          <TheFooterLogo />
        </li>

        <li>
          <TheFooterDonutEmail />
        </li>

        <TheFooterSocial />
      </ul>

      <ul
        class="footer__content typography__body2"
        style="flex-direction: row"
      >
        <li
          v-for="(link, linkIndex) in LINKS"
          :key="linkIndex"
        >
          <BaseLink
            class="footer__content-link"
            :href="link.href"
          >
            {{ link.text }}
          </BaseLink>
        </li>
      </ul>

      <ul class="footer__content typography__body2">
        <li
          v-for="(term, termIndex) in TERMS"
          :key="termIndex"
        >
          <BaseLink
            class="footer__content-term"
            :href="term.href"
          >
            {{ term.text }}
          </BaseLink>
        </li>

        <li>
          <TheFooterCopyright />
        </li>
      </ul>
    </div>
  </footer>
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

defineProps<Props>();

interface Props {
  is_white?: boolean;
}

const LINKS = computed(() => [
  {
    href: "/" + locale.value + "/rates",
    text: t("footer.links.rates"),
  },
  {
    href: "/" + locale.value + "/questions",
    text: t("footer.links.questions"),
  },
  {
    href: "/" + locale.value + "/contacts",
    text: t("footer.links.contacts"),
  },
]);

const TERMS = computed(() => [
  {
    href: "/" + locale.value + "/about/user-agreement",
    text: t("footer.terms.userAgreement"),
  },
  {
    href: "/" + locale.value + "/about/privacy-policy",
    text: t("footer.terms.privacyPolicy"),
  },
  {
    href: "/" + locale.value + "/about/cookie",
    text: t("footer.terms.cookie"),
  },
  {
    href: "/" + locale.value + "/about/license-agreement",
    text: t("footer.terms.licenseAgreement"),
  },
]);
</script>

<style scoped>
.footer {
  display: flex;
  color: var(--grey-1-5);
}

.footer.white {
  background: var(--white) !important;
}

.footer__container {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
}

.footer__content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

@media (--desktop) {
  .footer__content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    align-items: center;
  }
}

@media (--hover) {
  .footer__content-link:hover {
    color: var(--orange-3);
  }
}

.footer__content-term {
  color: var(--grey-3);
}

@media (--hover) {
  .footer__content-term:hover {
    color: var(--grey-2);
  }
}
</style>
